<template>
  <div class="cmd">
    <page-title></page-title>
    <div class="bg-dark system-info">
       <div  class="heart-beat">
        <p class="header">
          funciton

        </p>
        <div class="function">
          <div class="function-list">
            <template >
              <div @click="selectStream('UP')"  :class="{'selected':selected.type==='UP'}"
                   class="list-item">上行
              </div>
              <div @click="selectStream('DOWN')" :class="{'selected':selected.type==='DOWN'}"
                   class="list-item">下行
              </div>
            </template>
          </div>
          <div class="function-info">
            <template >
              <upstream  v-model="up" v-show="selected.type==='UP'" ></upstream>
              <downstream v-model="dw" v-show="selected.type==='DOWN'"  ></downstream>
            </template>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import steps from "./steps";
import textInput from "./text-input";
import upstream from "./upstream";
import downstream from "./downstream";
import dataArr from "./data-arr";
export default {
  name:'cmd',
  components:{
        pageTitle,
    steps,
    textInput,
    upstream,
    downstream,
    dataArr
  },
  data(){
    return{
      cmd:{},
      packetRule:{
        timeout: "", //连接超时时间
        len: {
          pt: [0, 0],
          ayl: "",
          ctStPt: "",
          ctCtLen: "" //# 长度{ 长度坐标, 长度解析方式, 长度包含内容起始坐标，长度包含固定内容长度 }
        },
        count: "", //数据包总长度(心跳握手特有)
        head: { ct: [2, 3] }, //包头{ 包头内容, 包头坐标 }
        tail: { ct: [2, 3] }, //包尾
        ck: { pt: [], ayl: "", ctStPt: 3, ctCtLen: 3 }, // 校验码{ 校验码坐标, 校验码解析方式, 校验码校验内容起始坐标, 校验码包含固定内容长度 }
        key: { ct: [255], pt: [] } // 功能key{ 功能key内容, 功能key坐标 }
      },
      up:{
        'packetRule': { },     // 数据包规则
        'dataType': 0,         // 返回数据类型，有0，1，2，3，0 代表返回成功或失败，1 代表返回dict,且key由用户设置, 2 代表返回为list, 数据类型为基本数据类型，3
        'ayl': [],             // 上行解析规则
        'aylParams': {},//上行解析方式需要的参数, {'aylName':'param'}
        'timeout': 0.001,       // 上行超时时间

      },
      dw:{
        'packetRule': { },
        'ayl': [],
        'bigDataAyl': '',
        'bigDataStPt': 1,
        'itlCount': 1,
        'startPts': [],
        'useUp': true,
        'aylParams': {},

      },
      selected:{
        type:'UP'
      }

    }
  },
  created(){
    this.up.packetRule=this.packetRule;
    this.dw.packetRule=this.packetRule;


  },
  methods:{
    selectStream(type){
      this.selected.type=type;

    },

    addCmds(){
      let url="cmds/create",
          params={
            auth_token:'default',
            category_id:'',
            up:{},
            dw:{},
            dataChangeType:0,
            nextCmd:null
          };
      this.$http.post(url,params).then(data=>{
        if(data.status_code==='SUCCEEDED'){
          this.$message.success('操作成功')
        }else{
          this.$message.error(`操作失败${data.msg}`)
        }
      })
    },
    saveCmds(cmd){
           let url=`cmds/${cmd.id}/edit`,
          params={
            auth_token:'default',
            category_id:'',
            up:{},
            dw:{},
            dataChangeType:0,
            nextCmd:null
          };
      this.$http.patch(url,params).then(data=>{
        if(data.status_code==='SUCCEEDED'){
          this.$message.success('操作成功')
        }else{
          this.$message.error(`操作失败${data.msg}`)
        }
      })

    }
  }

}
</script>

<style scoped lang="scss">
  .system-info {
    padding: 30px 60px;

  .header {
    font-size: pxTorem(22px);
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #1f2037;
  }
  }
  .base-info {
  .form-control {
    max-width: 500px;
  }
  }
  .form-body {
    padding: 5rem 0;
  }

  .data {
  .form-control {
    max-width: 150px;
  }
  }
  .data-info {
    padding: 0 2rem;
  }

  .data-header-style {
    display: flex;
    align-items: flex-start;
  .data-arr {
    position: relative;
  }
  .data-arr-delete {
    position: absolute;
    right: 0;
    top: -11px;
    z-index: 3;
    color: #fff;
    background: $primary;
    width: 1.2rem;
    border-radius: 50%;
    height: 1.2rem;
    text-align: center;
    line-height: 1.2rem;
    cursor: pointer;
  }
  .icon-c_add {
    line-height: 38px;
    font-size: 2rem;
    cursor: pointer;
  }
  }

  /*功能上下行编辑*/
  .function {
    display: flex;

  .function-list {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

  .list-item {
    border: 1px dashed #fff;
    border-right: none;
    border-radius: 10px 0 0 10px;
    margin-bottom: 1rem;
    padding: 1rem 2rem;
    cursor: pointer;
  }
  .list-item.selected {
    padding: 1rem 2.3rem;
    background: #fff;
    color: #000;
    border: none;
  }
  }

  .function-info {
    border: 1px solid #fff;
    border-radius: 5px;
    flex: 1;
    padding: 2rem 4rem;

  .form-body {
    padding: 4rem 0;
  }
  }

  .text-input {
    width: 125px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/view/subSystem/editCmds.vue